export { default as DetailsSummary } from './DetailsSummary'
